import {
  Box,
  Card,
  CardContent,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Button,
  Divider,
} from "@mui/material";
import { useState } from "react";

const PaymentPage = () => {
  const [method, setMethod] = useState("upi");

  return (
    <Box className="max-w-5xl mx-auto px-6 py-12 pt-28">
      <Typography variant="h4" fontWeight="bold" className="mb-8">
        Payment
      </Typography>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

        {/* LEFT - PAYMENT METHODS */}
        <Card className="rounded-2xl shadow-md">
          <CardContent>
            <Typography variant="h6" fontWeight="bold" className="mb-4">
              Select Payment Method
            </Typography>

            <RadioGroup
              value={method}
              onChange={(e) => setMethod(e.target.value)}
            >
              <FormControlLabel
                value="upi"
                control={<Radio />}
                label="UPI"
              />
              <FormControlLabel
                value="card"
                control={<Radio />}
                label="Credit / Debit Card"
              />
              <FormControlLabel
                value="cod"
                control={<Radio />}
                label="Cash on Delivery"
              />
            </RadioGroup>

            {/* Conditional UI */}
            {method === "upi" && (
              <TextField
                label="Enter UPI ID"
                fullWidth
                className="mt-4"
              />
            )}

            {method === "card" && (
              <div className="space-y-4 mt-4">
                <TextField label="Card Number" fullWidth />
                <TextField label="Card Holder Name" fullWidth />
                <div className="grid grid-cols-2 gap-4">
                  <TextField label="Expiry" />
                  <TextField label="CVV" />
                </div>
              </div>
            )}
          </CardContent>
        </Card>

        {/* RIGHT - ORDER SUMMARY */}
        <Card className="rounded-2xl shadow-md h-fit">
          <CardContent>
            <Typography variant="h6" fontWeight="bold" className="mb-4">
              Order Summary
            </Typography>

            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span>Subtotal</span>
                <span>₹ 2,499</span>
              </div>

              <div className="flex justify-between">
                <span>Shipping</span>
                <span>₹ 99</span>
              </div>

              <Divider />

              <div className="flex justify-between font-semibold text-base">
                <span>Total</span>
                <span>₹ 2,598</span>
              </div>
            </div>

            <Button
              variant="contained"
              fullWidth
              className="mt-6 py-3"
            >
              Pay Now
            </Button>
          </CardContent>
        </Card>
      </div>
    </Box>
  );
};

export default PaymentPage;
